<template>
    <div class="login-container">
        <logo></logo>
        <div class="wtw-container account-create-container clearfix">
            <form class="wtw-form">
                <h3 class="text-center">Reset Password</h3>
                <div class="input-container">
                    <div v-show="!successMessage">
                        <input v-model="userEmail"
                            v-validate="'required|email'"
                            type="email"
                            name="email"
                            placeholder="Email"
                            :class="{'error': errors.has('email') }"
                        />
                        <span v-show="errors.has('email')" class="error-message">{{ errors.first('email') }}</span>
                    </div>
                    <div v-show="successMessage" class="wtw-panel">
                        <p>
                            {{ successMessage }}
                        </p>
                    </div>
                </div>
                <transition-group name="fade">
                    <div v-if="!dataSending && !successMessage"
                         @click.stop="sendResetEmail()"
                         class="button pink"
                         :key="1">
                        Reset Password
                    </div>
                    <div v-if="dataSending"
                         class="loading-overlay"
                         :key="2">
                        <loader></loader>
                    </div>
                </transition-group>
            </form>
        </div>
        <div @click.stop="$router.go(-1)" class="back-button">
            Back
        </div>
    </div>
</template>

<script>

    import Logo from '../header/logo.vue';
    import Loader from '../common/loader.vue';

    export default{
        data(){
            return {
                userEmail: null,
                errorMessage: null,
                successMessage: false,
                dataSending: false,
            }
        },
        components: {Loader, Logo},
        methods: {
            sendResetEmail(){
                this.dataSending = true;
                this.$store.dispatch('auth/sendResetEmail', this.userEmail)
                        .then(response => {
                            this.dataSending = false;
                            this.errorMessage = null;
                            this.successMessage = response;
                            this.clearForm();
                        })
                        .catch(response => {
                            this.dataSending = false;
                            this.errorMessage = response;
                        });
            },
            clearForm(){
                this.userEmail = null;
            }
        },

    }
</script>